import useSWR from "swr";
import { fetcher, FetchError } from "lib/actions/fetcher";
import { endpointsAutodeskImport } from "../actions/endpointsAutodeskImport";
import { AutodeskHubModel } from "../types/AutodeskHubModel";
import { AutodeskFolderEntryModel } from "../types/AutodeskFolderEntryModel";

export function useAutodeskFolderContents(
  connectedAccountId: number | null,
  hub: AutodeskHubModel | null,
  projectId: string | null,
  folderId: string | null,
) {
  const { data, error, isLoading, mutate } = useSWR<
    AutodeskFolderEntryModel[],
    FetchError
  >(
    connectedAccountId !== null &&
      hub?.region &&
      projectId &&
      folderId &&
      endpointsAutodeskImport.folderContents(
        connectedAccountId,
        projectId,
        folderId,
        hub.region,
      ),
    fetcher,
    // A background retry would swap the error panel for a spinner, dropping a
    // Reconnect that is still waiting on its popup.
    { shouldRetryOnError: false },
  );

  return { entries: data, hasError: !!error, error, isLoading, mutate };
}
